import {NewviewOaBaseApi} from "./NewviewOaBaseApi";
import {Methods} from "@newview/infrastructure";


export class MaterialStoreApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'materialStore'
  }

  /**
   * 获取库存列表
   * @param params
   */
  public getList(params){
    return this.send(params,"getList",Methods.GET)
  }

}